import { useQuery } from "@tanstack/react-query";
import {
  getTimeslotFirstDay,
  getTimeslotFirstDoctorDay,
} from "../services/api/timeslot";

export const useGetTimeslotFirstDay = (
  eventId: string,
  categoryIds: string[],
  future: boolean,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ["getFirstDay", eventId, categoryIds, future],
    queryFn: () => getTimeslotFirstDay(eventId, categoryIds, future),
    enabled: Boolean(eventId && categoryIds.length > 0 && enabled),
    gcTime: 0,
  });
};

export const useGetTimeslotFirstDoctorDay = (
  eventIds: string[],
  onlyAssigned: boolean,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ["getTimeslotFirstDoctorDay", eventIds, onlyAssigned],
    queryFn: () => getTimeslotFirstDoctorDay(eventIds, onlyAssigned),
    enabled: Boolean(eventIds.length > 0 && enabled),
    gcTime: 0,
  });
};
